export const HOST_URL =
  process.env.NODE_ENV !== "production" ? "http://localhost:9004" : "";

export const INFRA_REQ_FETCH = "/api/v1/infrarequests";
export const INFRA_REQ_ORG_UNIT_FETCH = "/api/v1/infrarequests/org";
export const INFRA_REQ_RESOURCE_FETCH = " api/v1/infrarequests/resources";
export const INFRA_REQ_CREATE = "/api/v1/infrarequests";
export const INFRA_REQ_CREATE_PRODUCT_URL = "/api/v1/infrarequests/producturls";
export const CONFIG_RESOURCE = "/api/v1/resources";
export const CONFIG_RESOURCE_PKGS = "/api/v1/resourcepkgs";
export const ORG_UNITS = "/api/v1/businessunits";

export const ADO_PROJECT_CREATE = "/api/v1/ado/project";
export const ADO_PROJECT_ORCHESTRATE = "/api/v1/ado";
export const ADO_PIPELINE_ORCHESTRATE = "/api/v1/ado/pipeline";
export const ADO_PROJECT_LIST = "/api/v1/ado/projectrepolist";
export const DATA_GOVERNANCE_ORCHESTRATE = "/api/v1/dirgovreqs";
// "http://localhost:9004/api/v1/dirgovreqs";
export const COST_DASHBOARD_POWERBI_SIGNIN =
  "https://powerbi.microsoft.com/en-us/landing/signin/?ru=https%3A%2F%2Fapp.powerbi.com%2FautoAuthLogin.cshtml%3FnoSignUpCheck%3D1";
export const INFRA_URL = `/infra`;
export const ADMINLIST_URL = `${INFRA_URL}/User/GetUsersInRole?`;
export const REMOVEADMIN_URL = `${INFRA_URL}/User/RemoveUsersFromRole?`;
export const ADDADMIN_URL = `${INFRA_URL}/User/AddUsersToRole?`;
export const ADO_RELEASE_PARAMETER = "/api/v1/ado/adfoverrideparameters";
export const ADO_RELEASE_PARAMETER_SUBMIT = "/api/v1/ado/adfsubmitrelease";
export const MAESTRO_PRODUCTS_SHORT_NAME = `${INFRA_URL}/Product/GetProductList`;
export const MAESTRO_VERTICALS = `${INFRA_URL}/Product/GetAllVerticals`;
export const MAESTRO_NOTIFICATION = "/landingpage/v0/notifications";
export const CATEGORY = "?category=";

//AZURE STATS

export const RG_STATS = "/maestrobi/resource-groups";
export const RESOURCES_STATS = "/maestrobi/resources";
export const RG_COST = "/maestrobi/costbyresourcegroup";
export const LOCATION_COST = "/maestrobi/costbylocation";
export const SERVICE_COST = "/maestrobi/costbyservicename";
export const OVERALL_COST = "/maestrobi/cost";

export const LANDINGPAGE_BASE_URL =
  process.env.REACT_APP_RUN_ENV === "development"
    ? `https://maestro-dev.insights.maersk.com/landingpage`
    : `https://maestro.insights.maersk.com/landingpage`;

export const LUIS_HOST_NAME = "https://westus.api.cognitive.microsoft.com";
export const LUIS_HOST_URL = "/luis/api/v2.0/apps/";
export const LUIS_APP_ID = "2a1a5e5d-3b21-4348-aa41-0d68ac929d3c";
export const LUIS_VERSION_ID = "/versions/0.1/";
export const LUIS_SUBSCRIPTION_KEY = "";
export const USER_ACCESS_BASE_URL = `${ADMINLIST_URL}roleName=`;

export const ADO_REPO_CREATE = "/api/v1/ado/repo";
export const ADO_REPO_BRANCH_POLICY = "/api/v1/ado/branchpolicies";
export const ADO_MSC_CREATE = "/api/v1/ado/allenvironmentmsc";

export const ONTOLOGY_OPTIONS_URL = `${HOST_URL}/api/v1/ado/repoList`;

export const LP_CONTACT_CREATE = "/api/v1/lp/contactmsgs";

export const RA_ALERT_CC_HASURA_URL = "/v1/graphql";

/***** Notification URLS *******/
export const NOTIFICATION_TOKEN_URL =
  process.env.REACT_APP_RUN_ENV === "development"
    ? "https://fapazewemlitmaestronotification.azurewebsites.net"
    : "https://fapazewpmaestrosignalrnegotiate.azurewebsites.net";
export const NOTIFICATION_FUNCTION_CONNECTION_URL = `${NOTIFICATION_TOKEN_URL}/api/negotiate`;
/********* Notification URLS End ***********/

export const EMAIL_SS_BASE_URL = `https://notification-service.dev.maersk-digital.net/notification/api/v1/mail`;

export const LP_CHATBOT_TOKEN = "/api/v1/lp/bottoken";

export const MAESTRO_DATA_PREVIEW_BASE_URL =
  process.env.REACT_APP_RUN_ENV === "development"
    ? "https://maestro-data-catalog-develop.azurewebsites.net"
    : "https://maestro-data-catalog.azurewebsites.net";

export const RG_OVERVIEW_URL =
  "https://portal.azure.com/#@maersk.onmicrosoft.com/resource/subscriptions/ad88d8c8-5739-4619-b8dd-4cab5fd3c075/resourceGroups/";
/***** Loadnow URLS *******/
export const LOADNOW_URL =
  process.env.REACT_APP_RUN_ENV === "development"
    ? "https://webazewdmaestroloadnow.azurewebsites.net"
    : "https://webazewpmaestroloadnow.azurewebsites.net";
/********* Loadnow URLS End ***********/

export const RA_ALERT_CC_HASURA_HOST_NAME =
  process.env.REACT_APP_RUN_ENV === "development"
    ? `https://maestro-hasura-citus-develop.azurewebsites.net`
    : `https://maestro-hasura-citus-prod.azurewebsites.net`;

export const GEO_FENCING_CC_HASURA_HOST_NAME_NEW =
  process.env.REACT_APP_RUN_ENV === "development"
    ? `https://maestro-hasura-citus-develop.azurewebsites.net`
    : `https://maestro-hasura-citus-prod.azurewebsites.net`;

// Need to remove this changes once dev environment is ready for RA tool or geo fancing.
/**      ################# Start ################## **/
export const GEO_FENCING_CC_HASURA_HOST_NAME =
  process.env.REACT_APP_RUN_ENV === "development"
    ? `https://maestro-hasura-develop.azurewebsites.net`
    : `https://hgqlazewpmaestro.azurewebsites.net`;

/**      ################# End ################## **/

// Need to remove this changes once dev environment is ready for penny.
/**      ################# Start ################## **/
export const HASURA_HOST_NAME =
  process.env.REACT_APP_RUN_ENV === "development"
    ? `https://maestro-hasura-citus-develop.azurewebsites.net`
    : `https://maestro-hasura-citus-prod.azurewebsites.net`;
/**      ################# End ################## **/
/*** ###################### Intermodal-start #############**/
export const INTERMODAL_HASURA_ENDPOINT = "/v1/graphql";

export const INTERMODAL_HASURA_HOST_NAME =
  process.env.REACT_APP_RUN_ENV === "development"
    ? `https://maestro-hasura-citus-develop.azurewebsites.net`
    : `https://maestro-hasura-citus-prod.azurewebsites.net`;

/*** ###################### Intermodal-end #############**/

/****Maestro Fusion URLS ****/
export const GET_SPREADSHEET_BY_USER_ID = `${HOST_URL}/api/v1/maestroSheet/fetchSpreadAllSheets/`;
export const GET_SPREADSHEET_BY_ID = `${HOST_URL}/api/v1/maestroSheet/fetchSpreadSheet`;
export const DELETE_SPREADSHEET_BY_ID = `${HOST_URL}/api/v1/maestroSheet/deleteSpreadSheet`;
export const CREATE_SPREADSHEET = `${HOST_URL}/api/v1/maestroSheet/createSpreadSheet/`;
export const UPDATE_SPREADSHEET = `${HOST_URL}/api/v1/maestroSheet/updateSpreadSheet`;

console.log(
  "process.env.REACT_APP_RUN_ENV ===== ",
  process.env.REACT_APP_RUN_ENV
);
console.log("process.env.NODE_ENV ==== ", process.env.NODE_ENV);
/** RA Tool **/
export const MAESTROAPPS_RESOURCE_GUID =
  process.env.REACT_APP_RUN_ENV === "development"
    ? "api://95cb4153-97f4-4c9a-a4c2-a3850bf92c07"
    : "api://7d1df8f1-0bd1-4562-a948-4ca4aaf7bbb3";

// Need to remove this changes once dev environment is ready for RA tool or geo fancing.
/**      ################# Start ################## **/
export const GEO_FENCING_RESOURCE_GUID = "development"
  ? "api://95cb4153-97f4-4c9a-a4c2-a3850bf92c07"
  : "api://7d1df8f1-0bd1-4562-a948-4ca4aaf7bbb3";

/**      ################# End ################## **/

// ConatinerCloud config.
/**      ################# Start ################## **/
export const CONTAINER_CLOUD_RESOURCE_GUID =
  process.env.REACT_APP_RUN_ENV === "development"
    ? "api://aca121cd-bd0e-4814-b288-cbcc25b1cfda"
    : "api://865eea46-3328-47f4-824e-6c044f26ce18";

export const DATA_SERVICE_GUID = "api://f5e3b5c4-988c-4d09-9088-0892b299d0e1";

/**      ################# End ################## **/

export const DATA_ACCESS_HOST_URL =
  process.env.REACT_APP_RUN_ENV === "development"
    ? "https://maestro-data-develop.azurewebsites.net"
    : "https://maestro-data.azurewebsites.net";

export const DATA_ACCESS_URL_PATH = "/data.yaml";

export const LPF_AUTOMATION_API_URL = `${HOST_URL}/api/maestrofinautomation/saveFilterConditions`;

/* Maestro DGS */
export const dgs_url = `${HOST_URL}/api/maestrocontainercloud/graphql`;
export const HASURA_ACCESS_REQUEST = `/landingpage/v0/requests`;
export const HASURA_ACCESS_URL =
  "https://login.microsoftonline.com/05d75c05-fa1a-42e7-9cf1-eb416c396f2d/oauth2/v2.0/token";
export const HASURA_ACCESS_SCOPE =
  "api://df0485d8-aa0b-4d0a-acec-f902a3adfa99/.default";

/* MME APIs */
export const MME_SOURCESYSTEM_URL =
  process.env.REACT_APP_RUN_ENV === "development"
    ? "https://maestro-dev.insights.maersk.com/api/mme"
    : "https://maestro.insights.maersk.com/api/mme";

export const MME_FINDALL_SOURCE = `${MME_SOURCESYSTEM_URL}/findAllSources`;
export const MME_CREATE_SOURCE_URL = `${MME_SOURCESYSTEM_URL}/createSources`;
export const MME_EDIT_SOURCE_BY_NAME_URL = `${MME_SOURCESYSTEM_URL}/editSourcesByName/`;
export const MME_FIND_SOURCE = `${MME_SOURCESYSTEM_URL}/findBySourceName`;

/*Product catalogue*/
export const MME_PRODUCT_CATALOGUE_URL =
  process.env.REACT_APP_RUN_ENV === "development"
    ? "https://maestro-dev.insights.maersk.com/api/mme/productcatalogue"
    : "https://maestro.insights.maersk.com/api/mme/productcatalogue";

export const ALL_PRODUCT_PC = `${MME_PRODUCT_CATALOGUE_URL}/get-all-products`;
export const EDIT_REGISTERED_PRODUCT_PC = `${MME_PRODUCT_CATALOGUE_URL}/register`;
export const REGISTER_PRODUCT_PC = `${MME_PRODUCT_CATALOGUE_URL}/create`;
export const SPECIFIC_PROD_DETAILS = `${MME_PRODUCT_CATALOGUE_URL}/get-a-product`;
export const PLATFORM_BE_SWAGGER_URL =
  process.env.REACT_APP_RUN_ENV === "development"
    ? `https://maestro-dev.insights.maersk.com/api/v1/v2/api-docs`
    : `https://maestro.insights.maersk.com/api/v1/v2/api-docs`;

export const MME_BE_SWAGGER_URL =
  process.env.REACT_APP_RUN_ENV === "development"
    ? `https://apiazewdmaerstrommebackend.azurewebsites.net/api/mme/v2/api-docs`
    : `https://apiazewpmaerstrommebackend.azurewebsites.net/api/mme/v2/api-docs`;

export const PLATFORM_ENDPOINT = "1f81039c-50a0-441b-8968-8c9f2abaac4a";

export const LOADNOW_ENV_BASE_URL =
  process.env.REACT_APP_RUN_ENV.trim() === "development"
    ? `https://webazewdmaestroloadnow.azurewebsites.net`
    : `https://webazewpmaestroloadnow.azurewebsites.net`;

export const GITHUB_REPO_MIGRATION_URL = "/api/v1/versioncontrol/source/import";
export const GITHUB_REPO_DELETION_URL = "/api/v1/versioncontrol/repo/";
export const GITHUB_TEAM_ASSIGNMENT_URL = "/api/v1/versioncontrol/team/";
export const GITHUB_BRANNCH_PROTECTION_URL = "/api/v1/versioncontrol/repos/";
export const ADO_GEN2PIPLINE_AUTOMATION_URL = "/api/v1/ado/ontologyautomation";
